import API from "../../../../app/api";

export const fetchFloorFinderService = async (filters = []) => {

  const params = new URLSearchParams();
  filters.forEach((filter) => {
    const [key, value] = Object.entries(filter)[0];
    if (Array.isArray(value) && value.length) {
      params.append(key, value.join(","));
    } else if (value) {
      params.append(key, value);
    }
  });
  const response = await API.get(`/carpet-finder?${params.toString()}`);
  return response.data;
};

export const filterCarpetService = async ({
  selectedFilter = [],
  filters = {},
  page = 1,
  limit = 40,
}) => {
  const params = new URLSearchParams({ page, limit });
  selectedFilter.forEach((filter) => {
    const [key, value] = Object.entries(filter)[0];
    if (Array.isArray(value) && value.length) {
      params.append(key, value.join(","));
    } else if (value) {
      params.append(key, value);
    }
  });
  Object.entries(filters).forEach(([key, value]) => {
    if (Array.isArray(value) && value.length) {
      params.append(key, value.join(","));
    } else if (value !== null && value !== undefined && value !== "") {
      params.append(key, value);
    }
  });
  const response = await API.get(`/carpet-finder/items?${params.toString()}`);
  return response.data?.data;
};
